import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import EsimBlockData from '../../../Models/Content/EsimGeneralBlockData';
import EsimMainComponent from './EsimMainComponent';

import './esimStyle.scss';
export default class EsimGeneralBlock extends EpiComponent<EsimBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <EsimMainComponent iContent={this.props.data} context={this.getContext()} />;
  }
}


